import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { register } from "../../redux/auth";
import { clearMessage, setMessage } from "../../redux/message";
import { useTheme } from "@mui/material";
import {
  Alert,
  Box,
  Paper,
  Avatar,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { LockOutlined } from "@mui/icons-material";

const Register = () => {
  const theme = useTheme();
  const [successful, setSuccessful] = useState(false);
  const [loading, setLoading] = useState(false);
  const { message } = useSelector((state) => state.message);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearMessage());
  }, [dispatch]);

  const handleRegister = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const username = data.get("username");
    const email = data.get("email");
    const password = data.get("password");
    if (!username || !password) {
      setSuccessful(false);
      dispatch(setMessage("Both username and password are required"));
      return;
    }
    if (username.length < 3 || username.length > 20) {
      setSuccessful(false);
      dispatch(setMessage("Username must be between 3 and 20 characters long"));
      return;
    }
    if (password.length < 6 || password.length > 40) {
      setSuccessful(false);
      dispatch(setMessage("Password must be between 6 and 40 characters long"));
      return;
    }
    if (!email) {
      setSuccessful(false);
      dispatch(setMessage("Email is required"));
      return;
    }
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      setSuccessful(false);
      dispatch(setMessage("Email is wrong"));
      return;
    }
    setSuccessful(false);
    setLoading(true);
    dispatch(register({ username, email, password }))
      .unwrap()
      .then(() => {
        setSuccessful(true);
        setLoading(false);
      })
      .catch(() => {
        setSuccessful(false);
        setLoading(false);
      });
  };

  return (
    <Box
      sx={{
        minHeight: "calc(100% - 3rem)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: { xs: "1.5rem", md: "2.5rem" },
      }}
    >
      <Paper
        sx={{
          width: "100%",
          maxWidth: "400px",
          p: { xs: "2rem", sm: "2.5rem" },
          backgroundColor: theme.palette.background.alt,
        }}
      >
        <Box display="flex" flexDirection="column" alignItems="center">
          <Avatar
            sx={{
              width: 52,
              height: 52,
              mb: "0.75rem",
              bgcolor: theme.palette.secondary.main,
              color: theme.palette.primary[600],
            }}
          >
            <LockOutlined />
          </Avatar>
          <Typography variant="h3" fontWeight={700}>
            Create an account
          </Typography>
          <Typography
            variant="body1"
            color={theme.palette.text.secondary}
            sx={{ mt: "0.35rem", mb: "1.5rem" }}
          >
            It only takes a minute
          </Typography>
        </Box>
        {!successful && (
          <Box component="form" onSubmit={handleRegister} noValidate width="100%">
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Username"
              name="username"
              autoComplete="username"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="E-Mail"
              name="email"
              autoComplete="email"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="secondary"
              size="large"
              sx={{ mt: "1.25rem", mb: message ? "1rem" : 0 }}
              disabled={loading}
            >
              Register
            </Button>
          </Box>
        )}
        {message && (
          <Alert severity={successful ? "success" : "error"} sx={{ mt: successful ? 0 : undefined }}>
            {message}
          </Alert>
        )}
      </Paper>
    </Box>
  );
};

export default Register;
